import { render, staticRenderFns } from "./PackageDefaultSwitch.vue?vue&type=template&id=4b7e9ce2"
import script from "./PackageDefaultSwitch.vue?vue&type=script&lang=js"
export * from "./PackageDefaultSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports